import React from 'react';
import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import { LuWalletMinimal } from 'react-icons/lu';
import type { DonationFrequency } from '@kuow/core';

export interface DonationTotalBarProps {
  amount: number;
  frequency: DonationFrequency;
}

export const DonationTotalBar: React.FC<DonationTotalBarProps> = ({ amount, frequency }) => {
  const formattedAmount = `$${amount.toFixed(2)}`;
  const frequencyLabel = frequency === 'monthly' ? '/ Month' : '';

  return (
    <Box
      bg="bg.overcast"
      borderWidth={1}
      borderColor="border"
      borderTopRadius="md"
      px={12}
      pt={1.5}
      pb={3}
      mb={-1.5}
      w="full"
    >
      <HStack justify="center" gap={2}>
        <Icon as={LuWalletMinimal} boxSize={5} color="gray.fg" />
        <Text fontSize="sm" fontWeight="semibold" color="gray.fg">
          {formattedAmount} {frequencyLabel}
        </Text>
      </HStack>
    </Box>
  );
};
